import styled from "styled-components";
import { themes } from "../../../theme/theme";
const Segment = styled.div`
  background: #292929;
  width: 30rem;
  margin-bottom: 1rem;
  position: relative;
  height: 61rem;
  overflow: hidden;
  @media (min-width: 1921px) {
    width: 20%;
  }
  @media (max-width: 1330px) {
    height: 61rem;
  }

  @media ${themes.device.tablet} {
    width: 100%;
    height: 28rem;
  }

  .droppable {
    margin: 0 3%;
    height: 83%;
    div {
      -ms-overflow-style: none;
    }
    @-moz-document url-prefix() {
      div {
        scrollbar-width: thin;
        div {
          height: auto;
          scrollbar-width: none;
          #cardDivEdit {
            .border {
              min-height: 1.5rem;
            }
          }
        }
      }
    }

    div::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    div::-webkit-scrollbar-thumb {
      background: #7d7d7d;
    }
    div::-webkit-scrollbar-track {
      background-color: transparent;
    }
    button {
      display: none !important;
    }

    .inDroppable {
      height: 100%;
    }

    @media (max-width: 1330px) {
      height: 81%;
    }

    @media ${themes.device.tablet} {
      height: 70%;
    }
  }
`;
const WithImage = styled.div`
  display: flex;
  align-items: center;
  margin: 3rem 2rem 1rem;
  @media ${themes.device.laptop} {
    margin: 2rem 1rem;
  }
`;
const Image = styled.img`
  margin-right: 8%;
`;

const Title = styled.div`
  color: ${themes.colors.colorWhite};
  text-transform: uppercase;

  font-weight: bold;
  font-size: 1.7rem;
  line-height: 132.5%;
  @media ${themes.device.laptop} {
    font-size: 1.4rem;
    word-break: break-word;
  }
`;
const Number = styled.div`
  position: absolute;
  font-family: "Prompt", sans-serif;
  color: #3e3e3e;
  font-style: normal;
  font-weight: 600;
  font-size: 64px;
  line-height: 132.5%;
  display: flex;
  height: 90%;
  align-items: center;
  width: 100%;
  justify-content: center;
`;
export { Segment, WithImage, Image, Title, Number };
